var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEmptyBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 145,
    viewBox: "0 0 204 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1265_26061)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M0 115.202L74.5122 83.8379L118.016 110.279L49.9828 144.13L0 115.202Z",
    fill: "url(#paint0_linear_1265_26061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1374 91.6197L102.521 68.842V18.9336L52.5332 37.2288V89.3784C52.5327 89.8029 52.6406 90.2204 52.8467 90.5917C53.0528 90.9629 53.3504 91.2754 53.7112 91.4998C54.072 91.7242 54.4842 91.853 54.9088 91.8739C55.3333 91.8949 55.7562 91.8074 56.1374 91.6197Z",
    fill: "#EDA462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.517 117.936L53.9249 94.0737C53.5061 93.8676 53.1534 93.5487 52.9068 93.1529C52.6602 92.7571 52.5294 92.3003 52.5293 91.8341V37.2266L102.517 55.5286V117.936Z",
    fill: "#DD9B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.905 91.6197L102.521 68.842V18.9336L152.509 37.2288V89.3784C152.51 89.8029 152.402 90.2204 152.196 90.5917C151.99 90.9629 151.692 91.2754 151.331 91.4998C150.971 91.7242 150.558 91.853 150.134 91.8739C149.709 91.8949 149.286 91.8074 148.905 91.6197Z",
    fill: "#E59351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.47 0L102.521 18.9246L152.509 37.2283L171.479 18.1263L121.47 0Z",
    fill: "#F6C482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5664 18.1263L52.534 37.2283L102.522 18.9246L83.5731 0L33.5664 18.1263Z",
    fill: "#F6C482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.518 117.936L151.108 94.0737C151.527 93.868 151.881 93.5492 152.128 93.1534C152.375 92.7575 152.505 92.3005 152.506 91.8341V37.2266L102.518 55.5286V117.936Z",
    fill: "#F6C482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.481 96.8386L57.6662 87.9179C56.9829 87.6091 56.4277 86.8007 56.4277 86.1116V75.9167C56.4277 75.2344 56.9812 74.9171 57.6662 75.2259L77.481 84.1466C78.1642 84.4553 78.7211 85.2638 78.7211 85.9529V96.1478C78.7211 96.8369 78.1659 97.1473 77.481 96.8386Z",
    fill: "#CB794D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.012 77.7628L116.547 90.0608C115.667 90.4855 114.953 91.5363 114.953 92.4215C114.953 93.3068 115.667 93.6581 116.547 93.2334L142.012 80.932C142.889 80.509 143.596 79.4617 143.596 78.5867C143.596 77.7117 142.889 77.3364 142.012 77.7611V77.7628Z",
    fill: "#CB794D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.546 77.344C117.002 77.1098 117.39 76.762 117.672 76.3342L119.721 73.2964V83.7489C119.721 84.6358 120.437 84.994 121.315 84.571C122.193 84.148 122.907 83.0956 122.907 82.2103V71.7562L124.967 72.8103C125.276 72.9706 125.683 72.9297 126.095 72.7301C126.547 72.4969 126.932 72.1509 127.212 71.7255C127.835 70.8044 127.835 69.8032 127.212 69.4825L122.442 67.0229C122.281 66.9435 122.101 66.9099 121.921 66.9257C121.464 66.9826 121.039 67.1882 120.71 67.5107C120.516 67.6902 120.344 67.8924 120.198 68.1128L115.425 75.1812C114.804 76.1023 114.804 77.1035 115.425 77.4242C115.738 77.5828 116.141 77.5419 116.553 77.344H116.546Z",
    fill: "#CB794D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.461 69.6565C132.917 69.4218 133.305 69.0741 133.587 68.6467L135.637 65.6089V76.0733C135.637 76.9602 136.353 77.3184 137.229 76.8954C138.105 76.4724 138.823 75.42 138.823 74.5348V64.0687L140.883 65.1228C141.192 65.2814 141.598 65.2405 142.01 65.0426C142.463 64.8094 142.848 64.4634 143.127 64.038C143.751 63.1169 143.751 62.1157 143.127 61.795L138.361 59.3354C138.199 59.256 138.019 59.2224 137.839 59.2382C137.382 59.2951 136.956 59.5007 136.628 59.8232C136.431 60.002 136.256 60.2036 136.107 60.4236L131.332 67.4937C130.712 68.4148 130.712 69.416 131.332 69.7367C131.645 69.8953 132.048 69.8544 132.461 69.6565Z",
    fill: "#CB794D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.166 16.3301L93.633 34.499L102.517 55.5301L52.5395 37.2316L44.166 16.3301Z",
    fill: "#DF9F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.869 16.334L160.661 16.8525L152.499 37.2286L103.058 55.3396L102.53 55.5323H102.523L111.403 34.4961L160.869 16.334Z",
    fill: "#DF9F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.112 55.3826L102.397 55.2649L102.79 55.0978L94.0184 34.3379L93.6341 34.4965L93.248 34.6637L101.987 55.34L102.112 55.3826Z",
    fill: "#CB794D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2493 34.6608L44.0215 16.7221L44.3102 15.9375L94.0197 34.3367L93.2493 34.6608Z",
    fill: "#F6C482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.014 16.726L160.662 16.8522L111.722 34.8302L103.059 55.3393L102.532 55.5321H102.525L102.139 55.3649L111.086 34.1701L160.729 15.9414L160.871 16.3337L161.014 16.726Z",
    fill: "#F6C482"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1265_26061",
    x1: 46.4777,
    y1: 137.593,
    x2: 117.951,
    y2: 95.4164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B99678"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1265_26061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 144.13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyBox);
export default __webpack_public_path__ + "static/media/ic_empty_box.7bcbea016291c98a546fb98e7ab6cd55.svg";
export { ForwardRef as ReactComponent };